var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"msg-box"},[_c('div',{staticClass:"icon"},[_c('van-icon',{attrs:{"name":"warning","size":"40","color":"#ff976a"}})],1),_c('p',{staticClass:"desc"},[_vm._v(" 活动报名已截止，感谢您的关注，期待您的下次参与！ ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }